var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "info-row", attrs: { width: "12" } },
    [
      _vm.label
        ? _c(
            "vl-title",
            {
              staticClass: "vl-text--alt info-cell",
              class: _vm.indent ? "padding-left" : "",
              attrs: { "tag-name": "h6" },
            },
            [
              _vm._v(_vm._s(_vm.label) + ": "),
              _vm.tooltip
                ? _c("vl-icon", {
                    directives: [
                      {
                        name: "vl-tooltip",
                        rawName: "v-vl-tooltip",
                        value: _vm.tooltip,
                        expression: "tooltip",
                      },
                    ],
                    attrs: {
                      icon: "info-filled",
                      "mod-light": "",
                      "mod-after": "",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("div", {
        staticClass: "info-cell",
        domProps: { innerHTML: _vm._s(_vm.value) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }